/** The agent-login section of the Account page (``id="agents"`` there).
 *  Every "Link an agent login" action points here. */
export const AGENTS_ANCHOR = "agents";
export const AGENT_LOGIN_HREF = `/app/account#${AGENTS_ANCHOR}`;
